
import { Component, Prop, Vue } from 'vue-property-decorator'

import { isMembershipEnabled } from '@/helpers/Membership'

@Component({ name: 'MembershipLink' })
export default class extends Vue {
  // This only needs to be a prop so that the default can be excluded.
  @Prop({ default: 'register' })
  classNames: string

  @Prop({ default: false })
  renew: boolean

  get path(): string {
    return this.renew ? '/membership/renew' : '/membership'
  }

  get isMembershipEnabled(): boolean {
    return isMembershipEnabled(this.flags)
  }

  constructor() {
    super()
  }
}
